import { createContext, useContext, useEffect, useState } from 'react'

interface CSPContextType {
  nonce: string | null
}

const CSPContext = createContext<CSPContextType>({ nonce: null })

export function CSPProvider({ children }: { children: React.ReactNode }) {
  const [nonce, setNonce] = useState<string | null>(null)

  useEffect(() => {
    const generateClientNonce = () => {
      const timestamp = Date.now().toString(36)
      const random = Math.random().toString(36).substring(2)
      return `${timestamp}-${random}`
    }

    fetch(window.location.href, { method: 'HEAD' })
      .then(response => {
        const headerNonce = response.headers.get('X-Nonce')
        if (headerNonce) {
          setNonce(headerNonce)
        } else {
          setNonce(generateClientNonce())
        }
      })
      .catch(() => {
        setNonce(generateClientNonce())
      })
  }, [])

  return (
    <CSPContext.Provider value={{ nonce }}>
      {children}
    </CSPContext.Provider>
  )
}

export function useCSP() {
  return useContext(CSPContext)
}

